export const BUTTON_THEME = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  TERTIARY: 'tertiary',
  STYLELESS: 'styleless',
  DANGER: 'danger',
} as const;

export const BUTTON_ICON_POSITION = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const BUTTON_VARIANT = {
  DEFAULT: 'default',
  FULL_WIDTH: 'full_width',
  X_SMALL: 'x_small',
  SMALL: 'small',
  FORM_FIELD: 'form_field',
} as const;

export type ButtonTheme = (typeof BUTTON_THEME)[keyof typeof BUTTON_THEME];
export type ButtonIconPosition = (typeof BUTTON_ICON_POSITION)[keyof typeof BUTTON_ICON_POSITION];
export type ButtonVariant = (typeof BUTTON_VARIANT)[keyof typeof BUTTON_VARIANT];
